import fetchJSON from '../fetchJSON'
import getUserPhotoUrl from '@bt-react/libs/getUserPhotoUrl'

interface Channel {
  id: number
}

// This is only ever ran on the client-side
export interface UserProfileResponse {
  id: string
  companyName: string
  country: string
  firstName: string
  lastName: string
  jobTitle: string
  photoId: string
  photo: string
  isManager: boolean
  isChannelOwner: boolean
  isLoggedIn: boolean
  timeZone: string
  preAuth: string
  channels: [Channel] | []
  preAuthenticated: boolean
  created?: string
  sessionSuccessful?: boolean
}

export const defaultState: UserProfileResponse = {
  id: '',
  companyName: '',
  country: '',
  firstName: '',
  lastName: '',
  jobTitle: '',
  photoId: '',
  photo: '',
  isManager: false,
  isChannelOwner: false,
  isLoggedIn: false,
  timeZone: '',
  preAuth: '',
  channels: [],
  preAuthenticated: false,
  created: '',
  sessionSuccessful: false
}

export function formatProfileResponse (response, cloudinaryEnv = ''): UserProfileResponse {

  if (!response) return defaultState

  const [ userResponse, channelsResponse ] = response
  const { data: user } = userResponse
  const { data: channels } = channelsResponse

  if (!user) return defaultState

  const { timeZone } = user ?? ''
  const { id, photoId, roles } = user

  return {
    ...defaultState,
    ...user,
    preAuthenticated: user.preAuth && user.preAuth !== 'false',
    id,
    isManager: roles ? !!roles.find(role => role === 'manager' || role === 'operations') : defaultState.isManager,
    photoId,
    photo: photoId ? getUserPhotoUrl(photoId, '100', (cloudinaryEnv || process.env.CLOUDINARY_ENV)) : '',
    isChannelOwner: channels?.channels ? Boolean(channels.channels.length) : defaultState.isChannelOwner,
    channels: channels?.channels ?? defaultState.channels,
    isLoggedIn: true,
    timeZone,
    created: user.created
  }

}

async function fetchProfile (hostUrl = '', cloudinaryEnv = ''): Promise<UserProfileResponse> {

  let response

  try {

    response = await Promise.all([
      fetchJSON('fetchUser', `${hostUrl ||process.env.HOST}/webcast/api/user-session`, { includeCredentials: true }),
      fetchJSON('fetchChannels', `${hostUrl || process.env.HOST}/service/channel/v2/my/channels?pageSize=25`, { includeCredentials: true })
    ])

  }
  catch (e) {

  }

  return formatProfileResponse(response, cloudinaryEnv)

}

export default fetchProfile
